import {Http} from "@angular/http";
import {AsiFileService} from "@asi-ngtools/lib";
import {DocumentDossierDto, DossierDto, IDossierWebServiceClient} from "@resources/resources";
import {Component, EventEmitter, Input, Output} from "@angular/core";
import {environment} from "@environments/environment";

@Component({
  selector: 'list-documents',
  templateUrl: './list-documents.component.html',
  host: { 'class': 'cerba-list-documents' }
})
export class ListDocumentsComponent {

  @Input() dossier: DossierDto;
  @Output() onDownload = new EventEmitter<Date>();

  documents: Array<DocumentDossierDto> = [];

  constructor(private dossierClient: IDossierWebServiceClient, private fileUtils: AsiFileService, private http: Http) {
  }

  ngOnChanges() {
    this.dossierClient.findDocumentDossiers(this.dossier.identifiant).subscribe((documents) => {
      this.documents = documents;
    });
  }

  downloadFile(document: DocumentDossierDto) {
    this.fileUtils.getFileAsBlob(environment.contextPath + "api/dossiers/document/" + document.id).subscribe((fileAsBlob) => {
      this.saveToFile(fileAsBlob, document.name);
    });
  }

  saveToFile(fileAsBlob: Blob, fileName: string) {
    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(fileAsBlob, fileName);
    } else {
      let url = window.URL.createObjectURL(fileAsBlob);
      var anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.target = '_blank';
      anchor.href = url;
      anchor.dispatchEvent(new MouseEvent("click"));
      document.body.removeChild(anchor);
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/detail-resultat/list-documents/list-documents.component.ts